export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_30-e52368694eb01d2ee032eca087d0a0cc.jpg";